import { normalizeSitePath } from './seo';

const LEGACY_HOSTS = new Set(['getinduce.com', 'www.getinduce.com']);

/**
 * Convert legacy first-party HTTP(S) links to canonical relative paths.
 *
 * Only the two exact legacy hostnames are changed. Relative URLs, protocol-
 * relative URLs, other hosts (including subdomains), and non-HTTP schemes are
 * returned unchanged so data-driven content keeps its original destination.
 */
export function normalizeLegacyInternalHref(href: string | undefined): string | undefined {
  if (typeof href !== 'string' || !/^https?:\/\//i.test(href)) return href;

  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return href;
  }

  if (!LEGACY_HOSTS.has(url.hostname.toLowerCase())) return href;

  return `${normalizeSitePath(url.pathname)}${url.search}${url.hash}`;
}
